import "./techCarousel.css";

// Core Development
import javascript from "../../assets/skills/languages/js.png";
import typescript from "../../assets/skills/languages/ts.png";
import python from "../../assets/skills/languages/python.png";
import react from "../../assets/skills/web/react.svg";
import angular from "../../assets/skills/web/angular.svg";
import html from "../../assets/skills/web/html.svg";
import css from "../../assets/skills/web/css.svg";
import sass from "../../assets/skills/web/sass.svg";
import bootstrap from "../../assets/skills/web/bootstrap.svg";
import tailwind from "../../assets/skills/web/tailwindcss.svg";
import vue from "../../assets/skills/web/vue.svg";

// Backend, Data & AI
import nodejs from "../../assets/skills/backend/nodejs.svg";
import django from "../../assets/skills/backend/django.svg";
import flask from "../../assets/skills/backend/flask.svg";
import mysql from "../../assets/skills/databases/mysql.svg";
import mongodb from "../../assets/skills/databases/mongo.svg";
import firebase from "../../assets/skills/databases/firebase.svg";
import pytorch from "../../assets/skills/ai/pytorch.png";
import opencv from "../../assets/skills/ai/opencv.png";
import pandas from "../../assets/skills/ai/pandas.png";
import scikit from "../../assets/skills/ai/scikit.png";
import tensorflow from "../../assets/skills/ai/tensor.png";

// Tools, Platforms & Software
import git from "../../assets/skills/tools/git.svg";
import github from "../../assets/skills/tools/github.png";
import gitlab from "../../assets/skills/tools/gitlab.svg";
import linux from "../../assets/skills/tools/linux.svg";
import bash from "../../assets/skills/tools/bash.svg";
import npm from "../../assets/skills/tools/npm.svg";
import docker from "../../assets/skills/tools/docker.svg";
import postman from "../../assets/skills/tools/postman.png";
import vscode from "../../assets/skills/tools/visual.svg";
import overleaf from "../../assets/skills/tools/overleaf.svg";
import figma from "../../assets/skills/software/figma.png";
import photoshop from "../../assets/skills/software/photoshop.png";
import premiere from "../../assets/skills/software/premiere.png";
import canva from "../../assets/skills/software/canva.png";
import unreal from "../../assets/skills/software/unreal.svg";

const carouselGroups = [
    {
        title: "Core Development",
        direction: "left",
        items: [
        { name: "JavaScript", icon: javascript },
        { name: "TypeScript", icon: typescript },
        { name: "Python", icon: python },
        { name: "ReactJS", icon: react },
        { name: "Angular", icon: angular },
        { name: "HTML", icon: html },
        { name: "CSS", icon: css },
        { name: "Sass", icon: sass },
        { name: "Bootstrap", icon: bootstrap },
        { name: "Tailwind", icon: tailwind },
        { name: "Vue", icon: vue },
        ],
    },
    {
        title: "Backend, Data & AI",
        direction: "right",
        items: [
        { name: "NodeJS", icon: nodejs },
        { name: "Django", icon: django },
        { name: "Flask", icon: flask },
        { name: "MySQL", icon: mysql },
        { name: "MongoDB", icon: mongodb },
        { name: "Firebase", icon: firebase },
        { name: "PyTorch", icon: pytorch },
        { name: "OpenCV", icon: opencv },
        { name: "Pandas", icon: pandas },
        { name: "Scikit-learn", icon: scikit },
        { name: "TensorFlow", icon: tensorflow },
        ],
    },
    {
        title: "Tools, Platforms & Software",
        direction: "left",
        items: [
        { name: "Git", icon: git },
        { name: "GitHub", icon: github },
        { name: "GitLab", icon: gitlab },
        { name: "Linux", icon: linux },
        { name: "Bash", icon: bash },
        { name: "npm", icon: npm },
        { name: "Docker", icon: docker },
        { name: "Postman", icon: postman },
        { name: "VSCode", icon: vscode },
        { name: "Overleaf", icon: overleaf },
        { name: "Figma", icon: figma },
        { name: "Photoshop", icon: photoshop },
        { name: "Premiere", icon: premiere },
        { name: "Canva", icon: canva },
        { name: "Unreal", icon: unreal },
        ],
    },
    ];

    function TechRow({ title, items, direction = "left" }) {
    const duplicatedItems = [...items, ...items];

    return (
        <div className="tech-carousel-row">
        <div className="tech-carousel-row-header">
            <h3>{title}</h3>
        </div>

        <div className="tech-carousel-track-wrapper">
            <div className={`tech-carousel-track tech-carousel-track--${direction}`}>
            {duplicatedItems.map((item, index) => (
                <div className="tech-carousel-item" key={`${item.name}-${index}`}>
                <div className="tech-carousel-icon">
                    <img src={item.icon} alt={item.name} />
                </div>

                <span>{item.name}</span>
                </div>
            ))}
            </div>
        </div>
        </div>
    );
    }

    export default function TechCarousel() {
    return (
        <section className="tech-carousel-section" id="skills">
        <div className="glitch_section" data-text="Skills">
            Skills
        </div>

        <p className="tech-carousel-subtitle">
            Technologies, tools, and platforms I use for research, software
            development, and creative projects.
        </p>

        <div className="tech-carousel-container">
            {carouselGroups.map((group) => (
            <TechRow
                key={group.title}
                title={group.title}
                items={group.items}
                direction={group.direction}
            />
            ))}
        </div>
        </section>
    );
}